import React from "react";
import PropTypes from "prop-types";

import CoreStats from "core/Stats";
import BodyText from "core/BodyText";

import { StatsContainer, StatsSecondaryInfoText } from "./styles";

import colors from "core/colors";

const Stats = ({ totals }) => {
    return (
        <StatsContainer>
            <CoreStats
                heading={`$${totals.totalEarned}`}
                subheading="REVENUE"
                secondaryInfo={[
                    <BodyText
                        key={1}
                        size="lg"
                        copyColor={colors.alternative.lightMode.pine}
                    >
                        Paid {`$${totals.totalPaid}`}
                    </BodyText>,
                    <StatsSecondaryInfoText key={0}>
                        Queued{" "}
                        {`$${(totals.totalEarned - totals.totalPaid).toFixed(
                            2
                        )}`}
                    </StatsSecondaryInfoText>
                ]}
            />
            <CoreStats
                heading={(totals.fullResSales + totals.largeSales).toString()}
                subheading="SALES"
                secondaryInfo={[
                    <StatsSecondaryInfoText key={0}>
                        {`${totals.largeSales} Large`}
                    </StatsSecondaryInfoText>,
                    <StatsSecondaryInfoText key={1}>
                        {`${totals.fullResSales} Full-Res`}
                    </StatsSecondaryInfoText>
                ]}
            />
            <CoreStats
                heading={totals.freeDownloadCount.toString()}
                subheading="ATTRIBUTION DOWNLOADS"
                secondaryInfo={[
                    <StatsSecondaryInfoText key={0}>
                        Attribution and/or public domain
                    </StatsSecondaryInfoText>
                ]}
            />
        </StatsContainer>
    );
};

Stats.propTypes = {
    totals: PropTypes.object.isRequired
};

export default Stats;
